import { Injectable } from '@angular/core';

import { MemoryCacheRepository } from './memory-cache.repository';
import { OtherProfessionalPositionInterface } from '../data';

@Injectable()
export class OtherProfessionalPositionCacheRepository extends MemoryCacheRepository<OtherProfessionalPositionInterface[]> {}
